import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { useResolveNotificationMutation } from "@graphql/notifications/Notifications.g";

import { NotificationContextValue } from "./NotificationContext";

export const useNotificationProvider = (): NotificationContextValue => {
  const queryClient = useQueryClient();

  const resolveNotificationMutation = useResolveNotificationMutation();

  const invalidateNotificationQueries = useCallback(() => {
    // Invalidate all notification-related queries using the actual cache keys from GraphQL codegen
    // This will invalidate all queries that start with these prefixes, regardless of variables
    queryClient.invalidateQueries({
      predicate: (query) => {
        const queryKey = query.queryKey;
        return (
          Array.isArray(queryKey) &&
          (queryKey[0] === "Notifications" || queryKey[0] === "UnresolvedNotificationsTotalCount")
        );
      },
    });
  }, [queryClient]);

  const resolveNotification = useCallback(
    async (id: string) => {
      await resolveNotificationMutation.mutateAsync({ input: { id } });
      invalidateNotificationQueries();
    },
    [resolveNotificationMutation, invalidateNotificationQueries],
  );

  return {
    resolveNotification,
    invalidateNotifications: invalidateNotificationQueries,
  };
};